import once from 'lodash/once';
import partialCollapseGroup from './partialCollapseGroup.js';
import analytics from '../analytics';

const genericCollapse = {
  /**
   * This functions code is moved to initCollapses
   */
  initCollapse: once(() => {
    genericCollapse.initCollapses();
  }),

  /**
   * Init collapse click events and set element heights
   * Collapse will work universally, when parent element has class 'generic-collapse-group' and child elements use tpl-generic-collapse-box template.
   */
  initCollapses: () => {
    genericCollapse.checkGroupValidity();
    genericCollapse.initCollapseData();
    document.querySelectorAll('.generic-collapse-container').forEach(container => {
      const button = container.querySelector('.generic-ext-button');

      button.addEventListener('click', genericCollapse.toggleSlide);
      genericCollapse.setCollapseHeight(container);

    });

    var timeout;
    window.addEventListener(
      'resize',
      function() {
        if (!timeout) {
          timeout = setTimeout(function() {
            timeout = null;
            genericCollapse.resize();
          }, 500);
        }
      },
      false,
    );
  },

  /**
   * Init collapse click events and set element heights
   */
  initCollapseData: () => {
    let collapseContainers = document.getElementsByClassName('generic-collapse-content');
    Array.prototype.forEach.call(collapseContainers, function(el, index, array) {
      let hiddenHeight = 24;
      let hiddenContainers = el.querySelectorAll('.mini-collapse');
      Array.prototype.forEach.call(hiddenContainers, function(elem, index, array) {
        //console.log('elem', elem.scrollHeight);
        hiddenHeight = hiddenHeight + elem.scrollHeight;
      });
      //console.log('test', el.scrollHeight, hiddenHeight);

      // there is a bug somewhere here. adding el.scrollHeight + hiddenHeight will cause way too big max height, if parent el has partial-container inside it
      el.setAttribute('data-height', el.scrollHeight + hiddenHeight);
    });
  },
  /**
   * Check validity of open containers
   * Only allow one container open at a time
   */
  checkGroupValidity: () => {
    document.querySelectorAll('.generic-collapse-group').forEach(container => {
      let children = container.querySelectorAll('.generic-collapse-container');
      let hasOpen = false;
      Array.prototype.forEach.call(children, function(el, index, array) {
        // don't remove class on the first loop, but do remove it on all others.
        if (hasOpen) {
          el.classList.remove('open');
          el.getElementsByClassName('toggle-icon')[0].classList.remove('open');
        }
        if (el.classList.contains('open')) {
          hasOpen = true;
        }
      });
    });
  },
  /**
   * Target only elements that has the same parent element
   * @param  {object} target object
   */
  initCollapseGroup: target => {
    let parentGroup = target.closest('.generic-collapse-group');
    let containerGroup = parentGroup.querySelectorAll('.generic-collapse-container');

    Array.prototype.forEach.call(containerGroup, function(el, index, array) {
      if (!el.classList.contains('target')) {

        const isOpen = el.classList.contains('open');
        el.getElementsByClassName('toggle-icon')[0].classList.remove('open');
        el.classList.remove('open');

        //When opening another accoridan in the group, opened accordian menus are closed automatically here.
        //UI interaction for closing the element has to be triggered here "manually".
        if( isOpen ) {
          const button = el.querySelector('.generic-ext-button');
          button.setAttribute('data-gtm-type', 'close');
          const analyticData = analytics.extractAnalyticData( button );
          analytics.pushUIInteractionAnalytics( analyticData );
        }
      }
      el.classList.remove('target');
      genericCollapse.setCollapseHeight(el);
    });
  },
  /**
   * Target only elements that has the same parent element
   * @param  {object} container object
   */
  setCollapseHeight: container => {
    const child = container.querySelector('.generic-collapse-content');

    switch (true) {
    case container.classList.contains('open'):
    case container.classList.value && container.classList.value.indexOf('open') !== -1:
      child.style.maxHeight = child.getAttribute('data-height') + 'px';
      break;
    default:
      child.style.maxHeight = '0';
      break;
    }
  },
  /**
   * Toggle event for clicks
   * @param  {event} e events
   */
  toggleSlide: e => {
    e.preventDefault();
    partialCollapseGroup.initContainer();
    const container = e.target.closest('.generic-collapse-container');
    const button = e.target.closest('.generic-ext-button');
    let iconElement = container.getElementsByClassName('toggle-icon')[0];
    iconElement.classList.toggle('open');
    container.classList.toggle('target');
    container.classList.toggle('open');

    // adds open & close data-values for analytics purposes
    if (container.classList.contains('open')) {
      button.setAttribute('data-gtm-type', 'expand');
    } else {
      button.setAttribute('data-gtm-type', 'close');
    }

    genericCollapse.initCollapseGroup(container);
    genericCollapse.setCollapseHeight(container);
  },
  /**
   * Init generic section subtitle click
   */
  initGenericShowAll: once(() => {
    document.querySelectorAll('.generic-section .show-all').forEach(container => {
      container.addEventListener('click', genericCollapse.toggleGenericShowAll);
    });
  }),

  /**
   * Recalculates collapse groups elments sizes and things related to them.
   */
  resize: () => {
    genericCollapse.initCollapseData();
    document.querySelectorAll('.generic-collapse-container').forEach(container => {
      genericCollapse.setCollapseHeight(container);
    });
  },

  /**
   * Toggle event for clicks
   * @param  {event} e event
   */
  toggleGenericShowAll: e => {
    e.preventDefault();
    const parentContainer = e.target.closest('.generic-section');
    const child = parentContainer.querySelector('.generic-section-content');
    child.classList.toggle('open');
  },
};

export default genericCollapse;
